import { useMemo } from 'react'
import type { Tier } from '@mc/api'
import { tierMatchers } from '@mc/products'
import { useStaticData } from '@mc/static-data-react'
import { PlansTier, TierCollection } from '../types/planProducts'

const pruneTier = (tiers: Tier[], matcher: (x: Tier) => boolean) => {
  const tier = tiers?.find(matcher)

  return {
    ...tier,
    internalName:
      tier?.basicPlanIdentifier?.toLowerCase() ||
      tier?.premiumPlusPlanIdentifier?.toLowerCase() ||
      tier?.entitlement?.name?.toLowerCase(),
    productId: tier?.product?.id,
    displayMonthlyPrice: tier?.product?.monetizedYearPricePerMonth,
    displayMonthlyPriceWithDiscount:
      tier?.product?.monetizedYearPricePerMonthDiscounted,
    currencySymbol: tier?.product?.pricing?.currencySymbol,
  } as PlansTier
}

export const useTiersInfo = () => {
  const { tiers } = useStaticData<TierCollection>()

  const products = useMemo(
    () => ({
      individual: pruneTier(tiers, tierMatchers.first),
      duo: pruneTier(tiers, tierMatchers.second),
      family: pruneTier(tiers, tierMatchers.third),
      familyPlus: pruneTier(tiers, tierMatchers.fourth),
    }),
    [tiers],
  )

  return products
}
